module.exports = __webpack_public_path__ + "static/media/mlrit_logo.26c03c5d.png";